import React from "react";
import { Field } from "redux-form";
import InputField from "./InputField";
import Select from "./Select";
import {
  presenceValidation,
  lengthValidation,
  regionCheck,
} from "../../lib/utils/donation-form-validation";
import StateOptions from "../../lib/utils/state-options";
import CanadaRegions from "../../lib/utils/canada-regions";
import { FormattedMessage } from "react-intl";
import { phoneValidate } from "../../shared/validations";

const formatClassNames = (required, className = "") =>
  required ? `required-field ${className}` : className;

export default function addressComponent(props) {
  const { countries, showRequired, country, translateLocales } = props;

  const getZipLabel = (selectedCountry) => {
    return ["Canada", "United Kingdom", "Australia", "New Zealand"].includes(
      selectedCountry,
    )
      ? "Postal Code"
      : "Zip";
  };

  const getStateLabel = (selectedCountry) => {
    return selectedCountry === "Canada" ? "province" : "state";
  };

  const countryOptions = countries.map((country, idx) => {
    return (
      <option key={idx} value={country}>
        {country}
      </option>
    );
  });

  let regions = StateOptions;
  let regionsLabel = "State";
  let zipLabel = getZipLabel(country);
  let hideRegions = false;
  let stateLabel = getStateLabel(country);

  if (country === "Canada") {
    regions = CanadaRegions;
    regionsLabel = "Province";
  } else if (country && country !== "United States") {
    // if its not the us or canada, dont have regions populated
    regions = null;
    hideRegions = true;
  }

  return (
    <div>
      <label className={formatClassNames(false)} htmlFor="donating_cell_phone">
        {translateLocales ? <FormattedMessage id="phoneNumber" /> : "Phone Number"}
      </label>
      <Field
        aria-label="Phone Number"
        className="p-sm-b"
        name="address.cell_phone"
        component={InputField}
        validate={phoneValidate}
        type="text"
      />

      <label className={formatClassNames(showRequired)} htmlFor="donating_address1">
        {translateLocales ? (
          <FormattedMessage id="billingAddress1" />
        ) : (
          "Billing Address 1"
        )}
      </label>
      <Field
        aria-label="Billing Address 1"
        className="p-sm-b"
        name="address.address1"
        component={InputField}
        validate={
          showRequired
            ? [presenceValidation, lengthValidation(40)]
            : [lengthValidation(40)]
        }
        type="text"
      />

      <label htmlFor="donating_address2">
        <FormattedMessage id="billingAddress2" />
      </label>
      <Field
        aria-label="Billing Address 2"
        className="p-sm-b"
        name="address.address2"
        component={InputField}
        validate={[lengthValidation(40)]}
        type="text"
      />

      <label className={formatClassNames(showRequired, "third")} htmlFor="donating_city">
        {translateLocales ? <FormattedMessage id="city" /> : "City"}
      </label>
      <label
        className={formatClassNames(hideRegions ? "" : showRequired, "third")}
        htmlFor="donating_state">
        {hideRegions ? "" : <FormattedMessage id={stateLabel} />}
      </label>
      <label
        className={formatClassNames(showRequired, "third last")}
        htmlFor="donating_zip">
        <FormattedMessage id={zipLabel} />
      </label>

      <div className="clearfix">
        <div className="third">
          <Field
            aria-label="City"
            className="p-sm-b"
            name="address.city"
            component={InputField}
            validate={
              showRequired
                ? [presenceValidation, lengthValidation(30)]
                : [lengthValidation(30)]
            }
            type="text"
          />
        </div>

        <div className="third">
          {hideRegions ? (
            <span>&nbsp;</span>
          ) : (
            <Field
              className="p-sm-b"
              aria-label={regionsLabel}
              name="address.region"
              component={Select}
              children={regions}
              validate={showRequired ? [regionCheck] : null}
            />
          )}
        </div>

        <div className="third last">
          <Field
            className="p-sm-b"
            aria-label="Zip Code"
            name="address.zip"
            component={InputField}
            validate={
              showRequired
                ? [presenceValidation, lengthValidation(9)]
                : [lengthValidation(9)]
            }
            type="text"
          />
        </div>
      </div>

      <label className={formatClassNames(showRequired)} htmlFor="donating-country">
        {translateLocales ? <FormattedMessage id="selectCountry" /> : "Select A Country"}
      </label>
      <Field
        className="p-sm-b"
        aria-label="Country"
        name="address.country"
        component={Select}
        children={countryOptions}
        validate={showRequired ? [presenceValidation] : null}
      />
    </div>
  );
}
